/* eslint-disable */
import dayjs from 'dayjs';
import { ACTA_INICIO, ACTA_CIERRE } from 'constants/tipoMonitoreos';
import {
  MONITOREO_CANCELADO,
  MONITOREO_EN_PROCESO,
  MONITOREO_TERMINADO
} from 'constants/estatusMonitoreo';
import {
  HALLAZGO_VALIDADO,
  HALLAZGO_NO_VALIDADO,
  HALLAZGO_CANCELADO
} from 'constants/estatusHallazgos';
import { ACTA_NO_VALIDADA, ACTA_CANCELADA, ACTA_VALIDADA } from 'constants/estatusActas';
import { DATE_FORMAT_COLUMN_TABLE } from 'constants/dateFormat';

export const monitoreoDTO = (row) => {
  return {
    ...row,
    idForNotificar: `NP-${row.idMonitoreo}`,
    idForDescarga: `D-${row.idMonitoreo}`,
    idForValidar: `V-${row.idMonitoreo}`,
    estatusMonitoreoId: row.estatusMonitoreo,
    fechaRegistro: dayjs(row.fechaRegistro, 'YYYYMMDDHHmmss').locale('es'),
    fechaRegistroCadena: dayjs(row.fechaRegistro, 'YYYYMMDDHHmmss')
      .locale('es')
      .format(DATE_FORMAT_COLUMN_TABLE),

    estatus: (() => {
      if (row.hallazgos?.[0].estatus === 4) {
        return 'Validado';
      }
      if (row.estatusMonitoreo === 2) {
        return 'No validado';
      }
      return [MONITOREO_CANCELADO, MONITOREO_EN_PROCESO, MONITOREO_TERMINADO].find(
        (e) => e.value === row.estatusMonitoreo
      )?.label;
    })(),
    estatusCheck: [HALLAZGO_CANCELADO, HALLAZGO_NO_VALIDADO, HALLAZGO_VALIDADO].find(
      (e) => e.value === row.hallazgos?.[0].estatus
    )?.label
    , idEstatusCheck: [HALLAZGO_CANCELADO, HALLAZGO_NO_VALIDADO, HALLAZGO_VALIDADO].find(
      (e) => e.value === row.hallazgos?.[0].estatus
    )?.value
  };
};

const obtenerHallazgosValidados = (hallazgos) => {
  // eslint-disable-next-line consistent-return
  let estatus = true;
  hallazgos.forEach((element) => {
    if (element.estatus !== HALLAZGO_VALIDADO.value) estatus = false;
  });
  return estatus;
};

const obtenerHallazgosNoValidados = (hallazgos) => {
  // eslint-disable-next-line consistent-return
  let estatus = true;
  hallazgos.forEach((element) => {
    if (element.estatus !== HALLAZGO_NO_VALIDADO.value) estatus = false;
  });
  return estatus;
};

const obtenerEstatusGeneral = (hallazgos, estatusMonitoreo) => {
  let estatus;
  if (hallazgos !== undefined) {
    if (obtenerHallazgosValidados(hallazgos) && estatusMonitoreo === MONITOREO_TERMINADO.value)
      estatus = 'Validado';
    else if (
      obtenerHallazgosNoValidados(hallazgos) &&
      estatusMonitoreo === MONITOREO_TERMINADO.value
    )
      estatus = 'No Validado';
    else {
      estatus = [MONITOREO_CANCELADO, MONITOREO_EN_PROCESO, MONITOREO_TERMINADO].find(
        (e) => e.value === estatusMonitoreo
      )?.label;
    }
  }
  return estatus;
};

export const monitoreoEventosDTO = (row) => {
  return {
    ...row,
    idForNotificar: `NP-${row.idMonitoreo}`,
    idForDescarga: `D-${row.idMonitoreo}`,
    idForValidar: `V-${row.idMonitoreo}`,
    estatusMonitoreoId: row.estatusMonitoreo,
    fechaRegistro: dayjs(row.fechaRegistro, 'YYYYMMDDHHmmss').locale('es'),
    fechaRegistroCadena: dayjs(row.fechaRegistro, 'YYYYMMDDHHmmss').format(
      DATE_FORMAT_COLUMN_TABLE
    ),
    estatus:
      row.hallazgos[0]?.estatus === 4
        ? 'Validado'
        : [MONITOREO_CANCELADO, MONITOREO_EN_PROCESO, MONITOREO_TERMINADO].find(
            (e) => e.value === row.estatusMonitoreo
          )?.label,
    estatusCheck: [HALLAZGO_CANCELADO, HALLAZGO_NO_VALIDADO, HALLAZGO_VALIDADO].find(
      (e) => e.value === row.hallazgos[0]?.estatus
    )?.label,
    estatusGeneral: obtenerEstatusGeneral(row.hallazgos, row.estatusMonitoreo),
    checkValidacion: row?.hallazgos?.every((h) => h.estatus === 4) // 4 = validado
  };
};

export const actaInicioDTO = (row) => {
  const dataActaInicio = row.actas.find((acta) => acta.idTipoActa === ACTA_INICIO);
  return {
    ...row,
    idForNotificar: `NP-${dataActaInicio.idActa}`,
    idForDescarga: `D-${dataActaInicio.idActa}`,
    idForValidar: `V-${row.idMonitoreo}`,
    estatusActaId: dataActaInicio.estatus,
    fechaRegistro: dayjs(dataActaInicio.fechaApertura, 'YYYYMMDDHHmmss').locale('es'),
    fechaRegistroCadena: dayjs(dataActaInicio.fechaApertura, 'YYYYMMDDHHmmss').format(
      DATE_FORMAT_COLUMN_TABLE
    ),
    estatusActa: [ACTA_NO_VALIDADA, ACTA_CANCELADA, ACTA_VALIDADA].find(
      (e) => e.value === dataActaInicio.estatus
    )?.label
  };
};

export const actaCierreDTO = (row) => {
  const dataActaCierre = row.actas.find((acta) => acta.idTipoActa === ACTA_CIERRE);
  return {
    ...row,
    idForNotificar: `NP-${dataActaCierre.idActa}`,
    idForDescarga: `D-${dataActaCierre.idActa}`,
    idForValidar: `V-${row.idMonitoreo}`,
    estatusActaId: dataActaCierre.estatus,
    fechaRegistro: dayjs(dataActaCierre.fechaApertura, 'YYYYMMDDHHmmss').locale('es'),
    fechaRegistroCadena: dayjs(dataActaCierre.fechaApertura, 'YYYYMMDDHHmmss').format(
      DATE_FORMAT_COLUMN_TABLE
    ),
    estatusActa: [ACTA_NO_VALIDADA, ACTA_CANCELADA, ACTA_VALIDADA].find(
      (e) => e.value === dataActaCierre.estatus
    )?.label
  };
};

export const monitoreoEspectacularesDTO = (row) => 
{ 
  const dataActaInicio = row.actas.find((acta) => acta.idTipoActa === ACTA_INICIO);
  const dataActaCierre = row.actas.find((acta) => acta.idTipoActa === ACTA_CIERRE);
  const numeroHallazgos = row.hallazgos?.length;

  // MNI - Se obtienen los hallazgos no solo la cantidad
  const hallazgosLst = row.hallazgos? row.hallazgos : [];

  let valueCheckValidacion = false;
  if (numeroHallazgos > 0) {
    valueCheckValidacion = row.hallazgos.every((hallazgo) => hallazgo.estatus === 4);
  }
  return {
    /* MonitoreoEspectaculares */
    key: row.folio,
    idProcesoGral: row.idProcesoGral,
    folioMonitoreo: row.folio,
    idMonitoreo: row.idMonitoreo,
    fechaRegistro: dayjs(row.fechaRegistro, 'YYYYMMDDHHmmss').locale('es'),
    estatusMonitoreo: [MONITOREO_CANCELADO, MONITOREO_EN_PROCESO, MONITOREO_TERMINADO].find(
      (e) => e.value === row.estatusMonitoreo
    )?.label,
    /* Acta Inicio */
    idProcesoEspecifico: dataActaInicio.idProcesoEspecifico,
    fechaRegistroAI: dayjs(dataActaInicio.fechaApertura, 'YYYYMMDDHHmmss').locale('es'),
    fechaCreacionAI: dayjs(dataActaInicio.fechaApertura, 'YYYYMMDDHHmmss').format(
      DATE_FORMAT_COLUMN_TABLE
    ),
    idActaDescarga: dataActaInicio?.idActa,
    estatusAI: [ACTA_NO_VALIDADA, ACTA_CANCELADA, ACTA_VALIDADA].find(
      (e) => e.value === dataActaInicio.estatus
    )?.label,
    /* Acta Cierre */
    fechaRegistroAC:
      dataActaCierre?.fechaApertura !== undefined
        ? dayjs(dataActaCierre.fechaApertura, 'YYYYMMDDHHmmss').locale('es')
        : 'N/A',
    fechaCreacionAC:
      dataActaCierre?.fechaApertura !== undefined
        ? dayjs(dataActaCierre.fechaApertura, 'YYYYMMDDHHmmss').format(DATE_FORMAT_COLUMN_TABLE)
        : 'N/A',
    estatusAC:
      dataActaCierre?.estatus !== undefined
        ? [ACTA_NO_VALIDADA, ACTA_CANCELADA, ACTA_VALIDADA].find(
            (e) => e.value === dataActaCierre.estatus
          )?.label
        : 'N/A',
    /* Hallazgos */
    noHallazgos: numeroHallazgos,
    entidadHallazgo: row.estado,
    estatusHallazgo: valueCheckValidacion ? HALLAZGO_VALIDADO.label : HALLAZGO_NO_VALIDADO.label,
    checkValidacion: valueCheckValidacion,
    checkDescargaAC: 1,
    hallazgos: hallazgosLst
  };
};

export const monitoreoMediosDTO = (row) => {
  return {
    ...row,
    idForNotificar: `NP-${row.idMonitoreo}`,
    idForDescarga: `D-${row.idMonitoreo}`,
    idForValidar: `V-${row.idMonitoreo}`,
    estatusMonitoreoId: row.estatusMonitoreo,
    fechaRegistro: dayjs(row.fechaRegistro, 'YYYYMMDDHHmmss').locale('es'),
    fechaRegistroCadena: dayjs(row.fechaRegistro, 'YYYYMMDDHHmmss')
      .locale('es')
      .format(DATE_FORMAT_COLUMN_TABLE),
    estatus:
      // row.hallazgos?.[0].estatus === 4
      //   ? 'Validado'
      //   : [MONITOREO_CANCELADO, MONITOREO_EN_PROCESO, MONITOREO_TERMINADO].find(
      //       (e) => e.value === row.estatusMonitoreo
      //     )?.label,
      obtenerEstatusGeneral(row.hallazgos, row.estatusMonitoreo),
    estatusCheck: [HALLAZGO_CANCELADO, HALLAZGO_NO_VALIDADO, HALLAZGO_VALIDADO].find(
      (e) => e.value === row.hallazgos?.[0].estatus
    )?.label,
    folioCNCS: row.hallazgos?.[0].folioCNCS,
    fechaSincronizacion: dayjs(row.hallazgos?.[0].fechaSincronizacion, 'YYYYMMDDHHmmss').locale(
      'es'
    )
    , idEstatusCheck: [HALLAZGO_CANCELADO, HALLAZGO_NO_VALIDADO, HALLAZGO_VALIDADO].find(
      (e) => e.value === row.hallazgos?.[0].estatus
    )?.value
  };
};
